import { ReduxService } from 'dashboard-services/services';

import { ncsvCreatorActions } from 'actions/modules/tools';

export const ncsvCreatorInitialState = {
  id: undefined,
  open: false,
  columnConfigs: {},
  rawFile: undefined,
  onSave: undefined, 
  customOnSubmit: undefined
}

export default (state = ncsvCreatorInitialState, action) => {
  switch (action.type) {
    case ncsvCreatorActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}